import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map } from 'rxjs';
import { DomainService } from '@core/services/domain';
import { SessionService } from '@core/services/session';

function isPublishedValue(value: unknown): boolean | null {
  if (value === true || value === 'true') {
    return true;
  }

  if (value === false || value === 'false') {
    return false;
  }

  return null;
}

export const publishLinkGuard: CanActivateFn = (route): boolean | UrlTree | ReturnType<DomainService['getDomainDetails']> => {
  const router = inject(Router);
  const session = inject(SessionService);
  const domainService = inject(DomainService);

  const requestedPath = route.routeConfig?.path ?? '';

  if (requestedPath === 'link-not-published') {
    return true;
  }

  const isPublished = isPublishedValue(session.isPublishLink);

  if (isPublished !== null) {
    return isPublished ? true : router.parseUrl('/link-not-published');
  }

  const input = {
    Route: 'adms_form',
    Domain: window.location.host,
  };

  return domainService.getDomainDetails(input).pipe(
    map((res: any) =>
      isPublishedValue(res?.IsPublishLink) === true
        ? true
        : router.parseUrl('/link-not-published'),
    ),
  );
};
